//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Error',
  layout: localStorage.getItem('Token') ? 'default' : 'login',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageNotFound: '404 Not Found',
      // otherError: 'An error occurred',
    }
  },
  head() {
    const title = this.pageNotFound
    return {
      title,
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: this.favicon,
        },
      ],
    }
  },
  computed: {
    favicon() {
      return (
        this.$store.state.localStorage.userData?.Personalization?.Favicon ||
        '/BluConsole.png'
      )
    },
  },
}
